import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import {
  IClient,
  IService,
  IIssue,
  IStatusType
} from '../../../model/common.model';
import { ViewChild, Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { ConfirmDialogComponent } from '../../../confirm-dialog/confirm-dialog.component';
import { ClientStatusService } from '../../status/client-status.service';
import { ExcelService } from '../../../services/shared/excel/excel.service';
import { OTSExportpdfService } from '../../../services/shared/pdf/ots-exportpdf.service';
import { SortService } from '../../../util/sort.service';
import { CreateOutageModalComponent } from './create-outage-modal/create-outage-modal.component';
import { UpdateOutageModalComponent } from './update-outage-modal/update-outage-modal.component';
import { forkJoin } from 'rxjs';
import { ViewOutageUpdatesModalComponent } from './view-outage-updates-modal/view-outage-updates-modal.component';
import { map } from 'rxjs/operators';
import { EcaFormColumnModule, EcaPaginatorComponent, EcaPaginatorModule, EcaSearchModule } from '@drc-eca/eca-components-lib';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, NgModel } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { NgStyle, NgClass, DatePipe } from '@angular/common';


@Component({
    selector: 'app-update-issue',
    standalone: true,
    templateUrl: './update-issue.component.html',
    styleUrls: ['./update-issue.component.scss'],
    imports: [
      MatSort,
      MatDialogModule,
      EcaPaginatorModule,
      EcaSearchModule,
      MatFormFieldModule,
      MatInputModule,
      MatButtonModule,
      MatTable,
      MatColumnDef,
      MatHeaderCellDef,
      MatHeaderCell,
      MatCellDef,
      MatCell,
      MatHeaderRowDef,
      MatHeaderRow,
      MatRowDef,
      MatRow,
      MatCheckbox,
      FormsModule,
      NgStyle,
      NgClass,
      DatePipe
    ]
})
export class UpdateIssueComponent implements OnInit {
  private clientStatusSvc = inject(ClientStatusService);
  dialog = inject(MatDialog);
  private excelService = inject(ExcelService);
  private exportPDFService = inject(OTSExportpdfService);
  private sortService = inject(SortService);

  clientList: IClient[] = [];
  serviceList: IService[] = [];
  serviceSeverityList: IStatusType[] = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['title', 'status', 'severity', 'clients', 'services', 'createTime', 'action'];
  inprogress: boolean = false;
  issueList: IIssue[] = [];
  includeResolved: boolean = false;
  outageFilter: string;

  dialogRef: MatDialogRef<ConfirmDialogComponent>;

  @ViewChild('sort', { static: true }) sort: MatSort;
  @ViewChild(EcaPaginatorComponent) paginator: MatPaginator;

  selectedSeverity: string;
  selectedService: string;
  selectedClient: string;
  serviceStatusList: string[];

  selectedSeverityr: string;
  selectedServicer: string;
  selectedClientr: string;

  constructor() { }

  ngOnInit() {
    this.serviceStatusList = this.clientStatusSvc.getServiceStateList();
    this.getClients();
    this.getServices();
    this.getOutages();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.clientStatusSvc.getServiceStatusList().subscribe(statusTypes => {
      this.serviceSeverityList = statusTypes;
    });
  }

  getClients = () => {
    this.clientList = [];
    this.inprogress = true;
    this.clientStatusSvc.doGet('admin/client').subscribe((data: IClient[]) => {
      this.clientList = this.clientStatusSvc.sortArray(data || [], 'clientId', 'asc');
      this.inprogress = false;
    }, () => {
      this.inprogress = false;
      this.clientStatusSvc.openBadSnackBar(`error while getting client list.`);
    });
  }

  getServices = () => {
    this.serviceList = [];
    this.inprogress = true;
    this.clientStatusSvc.doGet('admin/service').subscribe((data: IService[]) => {
      this.serviceList = this.clientStatusSvc.sortArray(data || [], 'name', 'asc');
      this.inprogress = false;
    }, () => {
      this.clientStatusSvc.openBadSnackBar('Error while getting existing services.');
      this.inprogress = false;
    });
  }

  openCreateOutageModal() {
    const outageDialogRef = this.dialog.open(CreateOutageModalComponent, {
      data: {
        clientList: this.clientList,
        serviceList: this.serviceList,
        serviceStatusList: this.serviceStatusList,
        serviceSeverityList: this.serviceSeverityList.map(st => st.statusName)
      }
    });
    outageDialogRef.afterClosed().subscribe((result: any) => {
      if (!result.cancel) {
        const form = result.form.getRawValue();
        this.clientStatusSvc.doPost(`admin/outage`, form).subscribe(() => {
          this.getOutages();
        }, () => {
          this.clientStatusSvc.openBadSnackBar(`Error while creating issue.`);
        })
      }
    });
  }

  openUpdateOutageModal(outage: any) {
    const outageDialogRef = this.dialog.open(UpdateOutageModalComponent, {
      data: {
        clientList: this.clientList,
        serviceList: this.serviceList,
        serviceStatusList: this.serviceStatusList,
        serviceSeverityList: this.serviceSeverityList.map(st => st.statusName),
        outage: outage
      }
    });
    outageDialogRef.afterClosed().subscribe((result: any) => {
      if (!result.cancel) {
        const form = result.form.getRawValue();
        const commentForm = {
          status: form.status,
          comment: form.comment,
          outageId: outage.primaryKeyPart
        };
        Object.keys(outage).forEach(key => {
          outage[key] = form[key] ? form[key] : outage[key];
        })
        forkJoin([this.clientStatusSvc.doPost(`admin/outage`, outage), this.clientStatusSvc.doPost(`admin/outageupdate`, commentForm)]).subscribe(() => {
          this.getOutages();
        }, () => {
          this.clientStatusSvc.openBadSnackBar(`Error while updating issue.`);
        })
      }
    });
  }

  getOutages() {
    this.inprogress = true;
    this.clientStatusSvc.doGet(`admin/outage${!this.includeResolved ? '/active' : ''}`).subscribe((outages: any) => {
      this.dataSource.data = this.clientStatusSvc.sortArray((outages || []), 'createTime', 'desc');
      this.inprogress = false;
    }, () => {
      this.clientStatusSvc.openBadSnackBar(`Error while getting outage list.`);
      this.inprogress = false;
    })
  };

  getClass = (name: string) => {
    const status = this.serviceSeverityList.findIndex(s => s.statusName == name);
    if (status > -1) {
      return this.serviceSeverityList[status].statusColorCode;
    } else {
      return this.clientStatusSvc.getClass(name);
    }
  }

  getServiceNames(services: string[]) {
    return services.map(svc => this.serviceList.find((sl: any) => sl.primaryKeyPart == svc)?.name || svc);
  }

  filterOutages() {
    this.dataSource.filter = this.outageFilter.toString().toLowerCase().trim();
  }

  viewOutageUpdates(outage: any) {
    const outageDialogRef = this.dialog.open(ViewOutageUpdatesModalComponent, {
      data: {
        outage: outage,
        clientStatusSvc: this.clientStatusSvc
      }
    });
    outageDialogRef.afterClosed().subscribe(() => { })
  }



  // exportAllToPDFOrExcel(exportType: string = 'pdf', issueType: string = 'Active') {
  //   this.convertJsonToArray(this.getFilteredData(issueType), issueType === 'Active' ? this.outstandingColumns : this.resolvedColumns, issueType === 'Active' ? this.outstandingColumnAlias : this.resolvedColumnAlias).then(tableArrayData => {
  //     let chart: any = {
  //       chartName: `${issueType} Issue Report`,
  //       chartData: tableArrayData,
  //       columns: this.outstandingColumns,
  //       dateString: new Date().toLocaleString(),
  //       clientCode: issueType,
  //       dataTableTranspose: {
  //         dataSource: tableArrayData
  //       }
  //     };

  //     if (exportType === 'pdf') {
  //       this.exportPDFService.exportIssueReport(chart);
  //     } else {
  //       this.excelService.exportAllCTVCharts([chart], issueType, new Date().toLocaleString(), 'array');
  //     }
  //   })

  // }

  convertJsonToArray(data: any[], columns: string[], columnAlias: string[]) {
    return new Promise((resolve, reject) => {
      let arrayData = [];
      arrayData.push(columnAlias);
      let jsonArray: any[] = this.sortService.getSortedData(data, 'createDate', 'desc');
      jsonArray.forEach((jsonObj: any) => {
        let tempArray: string[] = [];

        Object.keys(jsonObj).forEach(key => {
          tempArray.splice(columns.indexOf(key), 0, jsonObj[key]);
        });
        arrayData.push(tempArray)
      });

      resolve(arrayData);
    });
  }
}
